<template>
    <v-layout column pt-2>
        <v-flex xs12>                                              
            <h4>Point of interests gekoppeld aan assetgroep: {{assetGroup.name}}</h4>            
            <v-data-table :headers="gridHeaders" :items="assetGroupGeoZoneEvents" hide-actions>
                <template slot="items" slot-scope="props">
                    <tr @click="editAssetGeoZoneEvent(props.item)">
                        <td>{{ props.item.geoZoneEvent.geoZone.name }}</td>
                        <td>{{ props.item.unitType.name }}</td>
                        <td style="text-align:center">{{ showActive(props.item.enterEventActive) }}</td>
                        <td style="text-align:center">{{ showActive(props.item.exitEventActive) }}</td>
                        <td style="text-align:center">{{ showDate(props.item.activeFrom) }}</td>
                        <td style="text-align:center">{{ showDate(props.item.activeTill) }}</td>
                        <td>{{ showtimeTable(props.item)}}</td>
                        <td style="text-align:center;">
                            <i style="cursor:pointer;"  class="far fa-map fa-2x" @click.stop="openGeoZoneOnMap(props.item.geoZoneEvent.geoZone)"></i>                            
                        </td>
                        <td>
                            <i class="fas fa-trash fa-2x" @click.stop="askToRemoveAssetGroupGeoZoneEvent(props.item)"></i>
                        </td>
                    </tr>
                </template>
            </v-data-table>       
            <!--                      
            <v-flex v-for="zoneEvent of unitTypeGeoZoneEvents" :key="zoneEvent.id" ma-2>
                <v-layout row justify-start> 
                    <v-flex sm2>

                    </v-flex>
                    <v-flex sm8 md6>
                        <v-layout column>
                            <v-flex><b>Geozone:</b> {{zoneEvent.geoZone.name}}</v-flex>
                            <v-flex>Binnenkom event: {{zoneEvent.enterEvent.name}}</v-flex>
                            <v-flex>Uitgaand event: {{zoneEvent.exitEvent.name}}</v-flex>
                        </v-layout>
                    </v-flex>                        
                </v-layout>
            </v-flex>     
            -->
            <v-pagination v-if="assetGroupGeoZoneEventsPagination && assetGroupGeoZoneEventsPagination.pagination.count > 0"             
                v-model="assetGroupGeoZoneEventsPagination.pagination.current_page"
                :length="assetGroupGeoZoneEventsPagination.pagination.total_pages"                           
                @input="loadAssetGroupGeoZoneEvents(false)">
            </v-pagination>                                        
        </v-flex>     
        <v-flex>
            <v-layout row>
                <v-spacer></v-spacer>
                <v-btn v-if="allowNew==1" @click="openPoiWizard()">POI toevoegen</v-btn>
            </v-layout>
        </v-flex>
        <v-flex v-if="selectedGeoZone">
            <dd-geo-zone-map @close="selectedGeoZone=null" :geoZone="selectedGeoZone"></dd-geo-zone-map>
        </v-flex>

        <v-dialog v-model="deleteDialog" max-width="450" v-if="deleteDialog">
            <v-card>
            <v-card-title class="headline">Weet u zeker dat u de groepskoppeling wilt verwijderen?</v-card-title>
            <v-card-text>
                U staat op het punt de koppeling te verwijderen tussen assetgroep {{assetGroup.name}} en POI {{selectedForDelete.geoZoneEvent.geoZone.name}}.
                </br></br>
                Na vewijdering zullen er geen events en acties meer geregistreerd worden voor alle assets in deze groep via de koppeling op lokatie {{selectedForDelete.geoZoneEvent.geoZone.name}}.
            </v-card-text>    
            <v-card-actions>
                <v-spacer></v-spacer>    
                <v-btn color="darken-1" flat="flat" @click="deleteDialog=false">Annuleren</v-btn>    
                <v-btn color="darken-1" flat="flat" @click="removeGeoZoneEvent()">Verwijder</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog  persistent v-model="newPoiDialog"  v-if="newPoiDialog">     
            <v-card>
                <v-card-title :class="`modal-title-bar`" >
                    <h4>Point of interest op assetgroep {{assetGroup.name}} {{mutateStatus}}</h4>
                    <v-spacer></v-spacer>
                    <i class="fas fa-times fa-2x" style="cursor:pointer;" @click="closePoiWizard()"></i>                                
                </v-card-title>                        
            </v-card>       
            <poi-wizard @isSaved="PoiIsCreated()" @close="closePoiWizard()" :assetGroupGeoZoneEvent="selectedAssetGroupGeoZoneEvent"></poi-wizard>
        </v-dialog>
    </v-layout>
</template>
<script>
    import { mapGetters } from "vuex";
    import * as types from "../../store/types"
    import DdGeoZoneMap from "../../components/global/DdGeoZoneMap"
    import PoiWizard from "../../components/geozone/PoiWizard"
    import _ from 'lodash'
    export default {
        components:{DdGeoZoneMap,PoiWizard},
        props: {
            allowNew: {
                type: Number,
                default:1 
            },
        },
        data(){
            return {
                selectedAssetGroupGeoZoneEvent:null,
                selectedForDelete:null,
                newPoiDialog:false,
                deleteDialog:false,  
                selectedGeoZone:null,
                gridHeaders: [
                    { text: "POI", sortable: false },
                    { text: "Hardware", sortable: false },                    
                    { text: "Aangekomen aan", sortable: false },
                    { text: "Verlaten aan", sortable: false },
                    { text: "Actief vanaf", sortable: false },
                    { text: "Actief tot", sortable: false },
                    { text: "Tijdtabel", sortable:false},
                    { text: "Toon op kaart", sortable: false },
                    { text: "", sortable: false }
                ],                  
            }
        },
        computed:{
            ...mapGetters({
                assetGroupGeoZoneEvents: types.ASSET_GROUP_GEO_ZONE_EVENTS,    
                assetGroupGeoZoneEventsPagination: types.ASSET_GROUP_GEO_ZONE_EVENTS_META                          
            }),
            mutateStatus(){
                return this.selectedAssetGroupGeoZoneEvent ? " aanpassen" : " configureren"   
            }
        },        
        methods: {
            editAssetGeoZoneEvent(assetGroupGeoZoneEvent){
                this.selectedAssetGroupGeoZoneEvent = assetGroupGeoZoneEvent
                this.newPoiDialog=true;
            },
            showActive(activeBool){
                return activeBool ? "Ja" : "Nee"
            },
            showtimeTable(assetGeoZoneEvent){
                if(!assetGeoZoneEvent.timeTable)
                    return "Geen"

                let txt  = assetGeoZoneEvent.timeTableZone == "inside" ? "binnen " : "buiten "
                    txt += assetGeoZoneEvent.timeTable.name
                return txt            
            },
            showDate(date){
                return date ? date.split(" ")[0].split("-").reverse().join("-") : "-"
            },
            openPoiWizard(){
                this.newPoiDialog=true
            },
            openGeoZoneOnMap(geoZone){
                this.selectedGeoZone=geoZone
            },
            askToRemoveAssetGroupGeoZoneEvent(assetGroupGeoZoneEvent){
                this.deleteDialog=true
                this.selectedForDelete = assetGroupGeoZoneEvent
            },
            removeGeoZoneEvent(){
                let vm = this 
                this.$store.dispatch(types.DELETE_ASSET_GROUP_GEO_ZONE_EVENT, {data:{assetGroupGeoZoneEventId:this.selectedForDelete.id}})                
                .then(()=>{
                    vm.$notify('POI koppeling succesvol verwijderd', { icon: 'check', type: 'success'})                        
                    vm.deleteDialog=false
                    vm.selectedForDelete=null       
                    vm.loadAssetGroupGeoZoneEvents()                                
                }).catch((e) => {
                    vm.$notify('POI koppeling niet verwijderd', { icon: 'error', type: 'error'})
                    vm.selectedForDelete=null                    
                    vm.deleteDialog=false
                })
            },
            closePoiWizard(){                
                this.newPoiDialog=false
                this.selectedAssetGeoZoneEvent=null
            },
            PoiIsCreated(){        
               this.closePoiWizard()
               this.loadAssetGroupGeoZoneEvents();
            },
            loadAssetGroupGeoZoneEvents(pageNr=1){   
                let data = {}
                if(this.unitType){
                    data.unitTypeId = this.unitType.id
                }

                data.assetGroupId = this.assetGroup.id;                
                if(!pageNr){         
                    pageNr = this.assetGroupGeoZoneEventsPagination.pagination.current_page
                }                    
                this.$store.dispatch(types.ASSET_GROUP_GEO_ZONE_EVENTS, {data:data, 
                                                                         params:{page:pageNr, include:"assetGroup,unitType, timeTable, geoZoneEvent.geoZone, geoZoneEvent.enterEvent, geoZoneEvent.exitEvent"}
                                                                        })                  
            }    
        },
        props: {
            unitType:{
                type:Object,
            },
            assetGroup: {
                type:Object,
                required:true
            },
            allowNew:{
                default:0                
            }
        },
        mounted(){               
            this.loadAssetGroupGeoZoneEvents()
        }
    }
</script>
<style scoped>

</style>